const mobileRoutes = [
  // {
  //   path: '/m',
  //   name: 'MobileHome',
  //   component: () => import('../views-mobile/Home.vue')
  // },
  // {
  //   path: '/m/about',
  //   name: 'MobileAbout',
  //   component: () => import('../views-mobile/About.vue')
  // },
  // {
  //   path: '/m/contact',
  //   name: 'MobileContact',
  //   component: () => import('../views-mobile/Contact.vue')
  // },
  // {
  //   path: '/m/founder',
  //   name: 'MobileFounder',
  //   component: () => import('../views-mobile/Founder.vue')
  // },
  // {
  //   path: '/m/product',
  //   name: 'MobileProductIndex',
  //   component: () => import('../views-mobile/product/Index.vue')
  // },
  // {
  //   path: '/m/product/:id',
  //   name: 'MobileProductDetail',
  //   component: () => import('../views-mobile/product/Detail.vue')
  // },
  // {
  //   path: '/m/user-info',
  //   name: 'MobileUserInfo',
  //   component: () => import('../views-mobile/userInfo.vue')
  // },
  // {
  //   path: '/m/account',
  //   name: 'MobileAccount',
  //   component: () => import('../views-mobile/Account.vue')
  // },
  // {
  //   path: '/m/enquiry',
  //   name: 'MobileEnquiry',
  //   component: () => import('../views-mobile/Enquiry.vue')
  // },
  // {
  //   path: '/m/enquiry-sub',
  //   name: 'MobileEnquirySub',
  //   component: () => import('../views-mobile/EnquirySub.vue')
  // }
  {
    path: '/m',
    name: 'Index',
    component: () => import('../views-mobile/Index.vue')
  },
  {
    path: '/m/index',
    name: 'MobileIndex',
    component: () => import('../views-mobile/Index.vue')
  }
]

export default mobileRoutes
